
$('[data-background], img[data-src]').imageLoader();

$(function() {
    $('[data-background], img[data-src]').imageLoader();

    // Open popup links inside a modal
	$(document).on('click', 'a.popup, a[target="popup"]', function(e) {
		e.preventDefault();

		var href = $(this).attr('href') || '';
		var path = href.indexOf('?') > 0 ? href.split('?')[0] : href;
		var host = window.location.protocol + "//" + window.location.host;
		var extraClass = $(this).data('popup-class');

		if (href === '') {
			return;
		}

		path = path.indexOf('#') > 0 ? path.split('#')[0] : path;
		var popupClass = path.match(/\.[a-z]{3,4}$/) ? 'fullwidth' : 'internal'; // link to file (pdf / xlsx / etc)?

		if (path.indexOf('http') === 0 && path.indexOf(host) !== 0) {
			popupClass = 'fullwidth'; // link to external url
		}

		if (extraClass) {
			popupClass += ' ' + extraClass;
		}

		// console.log(path, popupClass);

		if (href.indexOf('.pdf') > 0) {
			window.top.openPDFPopup(href);
		} else {
			window.top.openIframePopup(href, popupClass);
		}
	});

	// Make sure internal links inside popups are opened correctly
	$('body.popup .text a[href^="/"]').addClass('popup');

	// Make sure external links inside popups are opened in a new window
	$('body.popup a[href^="http"]').attr('target', '_blank');

	// Smooth scroll to anchors
	$('a[href^="#"]:not([data-bs-dismiss], [data-bs-toggle], .noscroll)').on('click', function(e) {
		if (!$(this).attr('href')) {
			return;
		}

		var id = $(this).attr('href').substring(1);
		var $element = $('[id="' + id + '"], [name="' + id + '"]').first();

		if (id !== '' && $element.length > 0) {
			e.preventDefault();
			smoothScrollTo($element);
			document.location.hash = id;
		}
	});

	// Copy text button
	$('.copy-text').on('click', function(e) {
		e.preventDefault();

		if (!navigator.clipboard.writeText) {
			return false;
		}

		console.log('copy', $($(this).data('target')).text());

		navigator.clipboard.writeText($($(this).data('target')).text()).then(() => {
			$(this).addClass('success');
		},() => {
			$(this).addClass('failed');
		});

		setTimeout(() => {
			$(this).removeClass('success').removeClass('failed');
		}, 2000);

		return true;
	});

	$('body').tooltip({
		selector: '[data-bs-toggle="tooltip-click"]',
		trigger: 'click',
		offset: "0,20",
	});

	$('#main').tooltip({
		selector: '[data-bs-toggle="tooltip"]',
		offset: "0,20",
	});

	$('.toggle-text-size').on('click', function(e) {
		e.preventDefault();

		var $html = $('html');
		var size  = $html.attr('data-text-size');

		// if (size === 'md') size = 'lg';
		// else if (size === 'lg') size = 'sm';
		// else size = 'md';

		if (size === 'lg') size = 'sm';
		else size = 'lg';

		$.get('/site/ajax/set_text_size.php?size=' +  size);
		$html.attr('data-text-size', size);
	});

	$(document).on('click', '.confirm', function(e) {
		e.preventDefault();
		e.stopImmediatePropagation();
		showConfirm({
			text:      $(this).data('confirm'),
			textYes:   $(this).data('text-yes'),
			textNo:    $(this).data('text-no'),
			urlYes:    $(this).attr('href'),
			onConfirm: $(this).data('onconfirm'),
		});
	});

	$(document).on('click', '.show-alert', function(e) {
		e.preventDefault();
		e.stopImmediatePropagation();
		showAlert($(this).data('alert'));
	});

    $('input[type=number]').on('input', function() {
        var min       = parseInt($(this).attr('min'));
        var max       = parseInt($(this).attr('max'));
		var maxLength = parseInt($(this).attr('maxlength'));
        var value     = parseInt($(this).val());

        if (!isNaN(max) && value > max) {
            $(this).val(max);
        }

        if (!isNaN(min) && value < min) {
            $(this).val(min);
        }

		if (!isNaN(maxLength)) {
			$(this).val($(this).val().substring(0, maxLength));
		}
    });

	$(document).on('click', '.btn, a', function(e) {
		var $btn = $(this);
		$btn.addClass('clicked');

		setTimeout(function() {
			$btn.removeClass('clicked');
		}, 100);
	});

	$(document).on('click', '.next-body-template', function(e) {
		e.preventDefault();

		var minTop        = $(this).offset().top;
		var $bodyTemplate = $('.body-template:visible').filter(function() {
			return $(this).offset().top >= minTop;
		}).first();

		smoothScrollTo($bodyTemplate, 0, 1000);
	});

    $(document).on('keydown', function(e) {
		if (['ArrowDown', 'ArrowUp'].indexOf(e.key) < 0) {
			return;
		}

		if ($('.page-template.sub_bodies').length === 0) {
			return;
		}

		if ($('.modal:visible').length > 0) {
			return;
		}

		var bodyTemplates = getElementsInViewport('.body-template:visible', 20);
		var bodyTemplate  = bodyTemplates.length > 0 ? bodyTemplates.shift() : false;
		var $target = {};

		if (!bodyTemplate) {
			return;
		}

        if (e.key === 'ArrowDown') {
			var minTop = $(bodyTemplate).offset().top + $(bodyTemplate).height();

			$target = $(bodyTemplate).siblings('.body-template:visible').filter(function() {
				return $(this).offset().top >= minTop;
			}).first();

        } else {
			$target = $(bodyTemplate).prev('.body-template');

			if ($target.length === 0 || $target.hasClass('block-count-1')) {
				$target = $('body');
			}
		}

		if ($target.length > 0) {
			e.preventDefault();
			smoothScrollTo($target, 0, 1000);
		}
    });

	$('.toggle-pass').on('mousedown', function(e) {
		e.preventDefault();

		var $passField = $(this).parent().find('input');
		var $icon      = $(this).find('i');
		var newType    = $passField.attr('type') === 'text' ? 'password' : 'text';

		$passField.attr('type', newType).focus();
		newType === 'text' ? $icon.addClass('fa-eye-slash') : $icon.removeClass('fa-eye-slash');
	}).on('click', function(e) {
		e.preventDefault();
	});

   	$('.modal').on('show.bs.modal', function(e) {
   		$('body').addClass('modal-active');
   	}).on('hide.bs.modal', function(e) {
   		$('body').removeClass('modal-active');
		$('.popup-modal iframe').off('load').attr('src', 'about:blank').attr('style', '');
   	});

	$('select').on('change empty-init', function() {
		$(this).toggleClass('empty', $(this).val() === '');
	}).trigger('empty-init');

});

$(window).on('resize resize-init', function() {
	checkSidebarHeight();
    document.documentElement.style.setProperty('--vh', `${window.top.innerHeight}px`)
}).trigger('resize-init');

var dateTimePickerIcons = {
    time: 'fa fa-clock',
    date: 'fa fa-calendar',
    up: 'fa fa-chevron-up',
    down: 'fa fa-chevron-down',
    previous: 'fa fa-chevron-double-left',
    next: 'fa fa-chevron-double-right',
    today: 'fa fa-crosshairs',
    clear: 'fa fa-trash',
    close: 'fa fa-times'
};


$(window).on('mousewheel', function() {
    $(window).trigger('scroll');
});

setInterval(function() {
    $.get('/lib/keepalive.php');
}, 1000 * 60 * 10);
